import React from 'react'

import { StyledSpinner } from './style'

const Spinner = ({ size = '16px', secondaryColor=false }) => {
  return <StyledSpinner secondaryColor={secondaryColor} size={size} data-test="spinner" data-testid="test-spinner" />
}

export default Spinner
